"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetSearchResultsFacets = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _presentationHttp = require("@ori/presentation-http");
var _react = require("react");
var _api = require("../../../api");
/* istanbul ignore file @preserve */ const useGetSearchResultsFacets = (param)=>{
    let { query } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers } = (0, _presentationHttp.useHeaders)();
    const getFacets = (0, _react.useCallback)(async (values)=>{
        const response = await (0, _api.getSearchResultsFacets)({
            graphQlNetUrl,
            headers,
            query,
            facetFiltering: values
        });
        return response;
    }, [
        graphQlNetUrl,
        headers,
        query
    ]);
    return {
        getFacets
    };
};
exports.useGetSearchResultsFacets = useGetSearchResultsFacets;
